import React from "react";
// import { useEffect } from "react";
import AddUser from "../../AddUser";
// import { useNavigate } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";

const AddUserVerify = ({ userDetails }) => {
  const { role: userRole } = useAuth();
   
  if (!userDetails) {
    // Handle the case when userDetails is not available
    return <div>Loading...</div>;
  }

  return (
    <div>
      {userRole === "ROLE_ADMIN" && <AddUser userDetails={userDetails} />}
      {userRole === "ROLE_USER" && <Navigate to="/" />}
    </div>
  );
};

export default AddUserVerify;
